import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';
import { ScrollPadding } from '../../entities/scroll-padding.entity';

@Injectable({ providedIn: 'root' })
export class ShScrollPaddingService {
    private readonly scrollPadding$: BehaviorSubject<ScrollPadding | undefined> = new BehaviorSubject<
        ScrollPadding | undefined
    >(undefined);

    getScrollPadding(): Observable<ScrollPadding | undefined> {
        return this.scrollPadding$;
    }

    setScrollPadding(padding: ScrollPadding | undefined): void {
        this.scrollPadding$.next(padding);
    }
}
